
import React, { useState, useRef, useEffect }  from 'react';
import { useRecorder } from '../../context/MicContext';
import AudioLevelIcon from './AudioIcon';

const AudioAnalyser = ({ raiseAudioError }) => {
    const { recordingState, audioDeviceRef } = useRecorder();
    const [audioData, setAudioData] = useState(new Uint8Array(0));
    const audioContextRef = useRef(null);
    const analyserRef = useRef(null);
    const sourceRef = useRef(null);
    const rafIdRef = useRef(null);
    const dataArrayRef = useRef(null);
  
    useEffect(() => {
      if (recordingState !== "recording") return;
      const audioContext = new (window.AudioContext || window.webkitAudioContext) ();
      audioContextRef.current = audioContext;
      const analyser = audioContext.createAnalyser();
      analyserRef.current = analyser;
      dataArrayRef.current = new Uint8Array(analyser.frequencyBinCount);
    
      return () => {
        analyser.disconnect();
        audioContext.close();
      };
    }, [recordingState]);
    
    useEffect(() => {
      if (recordingState !== "recording" || !audioDeviceRef.current || !analyserRef.current) return;
    
      const audioCtx = audioContextRef.current;
      audioCtx.resume();
    
      const source = audioCtx.createMediaStreamSource(audioDeviceRef.current);
      sourceRef.current = source;
      source.connect(analyserRef.current);
    
      const tick = () => {
        analyserRef.current.getByteTimeDomainData(dataArrayRef.current);
        setAudioData([...dataArrayRef.current]);
        rafIdRef.current = requestAnimationFrame(tick);
      };
    
      rafIdRef.current = requestAnimationFrame(tick);
    
      return () => {
        cancelAnimationFrame(rafIdRef.current);
        source.disconnect();
      };
    }, [recordingState, audioDeviceRef]);
  
    useEffect(() => {
      if (recordingState !== "recording") return;
    
      const interval = setInterval(() => {
        const buffer = dataArrayRef.current;
        if (!buffer || buffer.length === 0) return;
    
        const isSilent = buffer.every((val) => val === 128);
    
        if (isSilent) {
          raiseAudioError();
          console.warn("Mic appears to be silent!");
        }
      }, 5000); // Check every 5 seconds
    
      return () => clearInterval(interval);
    }, [recordingState]);
    
    return <AudioLevelIcon audioData={audioData}/>;
  };
  
  export default AudioAnalyser;